const AccessToType = Object.freeze({
  //Personal Access
  Vacation: 6,
  Mission: 8,
  IO: 10,
  ExtraWork: 11,
  SpecificExtraWork: 65,

});

export default AccessToType;